module.exports = __webpack_public_path__ + "static/media/restaurantes-200x200.ea70d251.png";